import React from 'react';

import { FlexColumn } from 'ui-components/components/flex';

import style from './grid-layout.module.less';
import { LabelHistory } from './sections/label-history';
import { ShipmentDetails } from './sections/shipment-details';
import { ShipmentItems } from './sections/shipment-items';
import { useShipmentsPanelContext } from '../side-panel/shipments/shipments-panel-context-provider';

export const GridLayout = () => {
  const sidePanelFulfillmentPlans = useShipmentsPanelContext() || [];
  return (
    <div className={style['overview-grid-layout']}>
      <FlexColumn className={style['shipment-details']}>
        <ShipmentDetails />
      </FlexColumn>
      <FlexColumn className={style['label-history']}>
        <LabelHistory sidePanelFulfillmentPlans={sidePanelFulfillmentPlans} />
      </FlexColumn>
      <FlexColumn className={style['shipment-items']}>
        <ShipmentItems />
      </FlexColumn>
    </div>
  );
};
